import React from 'react';
import { useController, ApplicationView } from '@aha-app/mvc';
import RecordPickerController from '../controllers/RecordPickerController';

const MESSAGES = {
  noResults: {
    heading: 'Nothing found',
    subheading: 'Try refining your search terms',
    icon: 'fa-regular fa-cards-blank color-tertiary',
  },
  allSelected: {
    heading: 'All the records are selected',
    subheading: 'Search for something else or add records to the whiteboard!',
    icon: 'fa-regular fa-cards-blank color-tertiary',
  },
};

const EmptyStateContent: React.FC = () => {
  const controller = useController(RecordPickerController);
  const results = controller.getVisibleResults();

  const hasResults = results.length > 0;

  const { heading, subheading, icon } = hasResults
    ? MESSAGES.allSelected
    : MESSAGES.noResults;

  return (
    <div className='tw-flex tw-flex-col tw-grow tw-justify-center'>
      <aha-empty-state>
        <h2 slot='title'>{heading}</h2>
        <div className='tw-text-h-200 mb-4' slot='icon'>
          <i className={icon} />
        </div>
        <p>{subheading}</p>
      </aha-empty-state>
    </div>
  );
};

export default ApplicationView(EmptyStateContent);
